import { useQuery } from "@tanstack/react-query";

import { Response } from "../types";

import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";
import { QuestionnaireResponse } from "@/routes/onboarding/types";

export const useUserOnboardingQuestion = (userToken: string, options?: { enabled?: boolean }) =>
  useQuery<Response<QuestionnaireResponse[], "onboarding_responses", string>>(
    [ENDPOINTS.user_onboarding, userToken],
    () =>
      fetch(ENDPOINTS.user_onboarding, {
        headers: authHeader(userToken),
      }).then(handleResponse),
    {
      enabled: (options?.enabled ?? true) && Boolean(userToken),
    },
  );
